export const TILE = 'tile';
export const THUMB = 'thumb';
export const DETAIL = 'detail';
export const ORIGINAL = 'original';
export const BADGE_TILE = 'badge_tile';
export const BADGE_DETAIL = 'badge_detail';



// WEBPACK FOOTER //
// ./mcart/assets/src/js/app/constants/api-images-types.js